import { AlarmChannel } from "apis/alarm-settings";
import { useToast } from "hook/useToast";
import React from "react";
import UI from "@mile-meeting/mile-ui";
import { MainPolicySettingBlock, PolicyCustomizeSection, SubPolicySettingBlock } from "uis/Section";

type MeetingNotificationSettingProps = {
  isActivated?: boolean;
  channel?: AlarmChannel;
  onChange?: (value: boolean) => void;
  onChangeChannel?: (channel: AlarmChannel) => void;
  isSlackConnected?: boolean;
  isMeetingAlarmEnabledByAdmin?: boolean;
};

const MeetingNotificationSetting: React.FC<MeetingNotificationSettingProps> = ({
  isActivated = false,
  channel = AlarmChannel.EMAIL,
  onChange,
  onChangeChannel,
  isSlackConnected = false,
  isMeetingAlarmEnabledByAdmin = true,
}) => {
  const { showToast } = useToast();
  return (
    <PolicyCustomizeSection title="회의 알림">
      <MainPolicySettingBlock
        haveChildren={isActivated}
        title="회의 알림 활성화"
        description="활성화 시 회의 시작 예정 / 노쇼 경고 / 노쇼 취소에 대한 알림을 전송합니다."
        rightChildren={
          <div style={{ position: "relative" }}>
            <UI.Selection.Toggle.Default
              state={isActivated}
              onChange={onChange}
              disabled={!isMeetingAlarmEnabledByAdmin}
              size="large"
            />
            {!isMeetingAlarmEnabledByAdmin && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                onClick={() => showToast("관리자가 비활성화한 알림입니다.", "warning")}
              />
            )}
          </div>
        }
      />
      {isActivated && (
        <SubPolicySettingBlock
          title="회의 알림 채널"
          description="설정한 채널로 회의 알림을 전송합니다."
          rightChildren={
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", gap: 4 }} onClick={() => onChangeChannel?.(AlarmChannel.EMAIL)}>
                <UI.Radio selected={channel === AlarmChannel.EMAIL} />
                <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                  E-mail
                </UI.Typography>
              </div>
              <div
                style={{ display: "flex", gap: 4 }}
                onClick={() => {
                  if (isSlackConnected) onChangeChannel?.(AlarmChannel.SLACK);
                  else showToast("Slack 미연동 상태입니다. 서비스 연동 관리에서 Slack을 연동해 주세요.", "warning");
                }}
              >
                <UI.Radio selected={channel === AlarmChannel.SLACK} disabled={!isSlackConnected} />
                <UI.Typography
                  type="body01 normal"
                  fontStyle="regular"
                  color={isSlackConnected ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
                >
                  Slack
                </UI.Typography>
              </div>
            </div>
          }
        />
      )}
    </PolicyCustomizeSection>
  );
};

export default React.memo(MeetingNotificationSetting);
